import FormControl from './FormControl'
import FormTemplate from './FormTemplate'
import FormValidable from './FormValidable'

export default class FormGroup extends FormValidable {
  constructor (options = {}) {
    super(options)
    this.name = options.name
    this.form = options.form
    this.onSubmit = (event) => {
      if (event?.preventDefault) event.preventDefault()
      options.onSubmit()
    }
    this.update = options.update
    this.controls = Object.fromEntries(Object.entries(options.controls).map(([controlName, controlOptions]) => {
      const FormElement = (controlOptions.type === 'template' && FormTemplate) || (controlOptions.type === 'group' && FormGroup) || FormControl
      return [controlName, new FormElement({ ...controlOptions, name: controlName, form: this })]
    }))
    this.template = options.template
    this.submit = options.submit || null
  }

  get value () {
    return Object.fromEntries(Object.entries(this.controls || {}).map(([controlName, control]) => [controlName, control.value]))
  }

  validateFromChildren () {
    this.valid = this.valid && Object.values(this.controls).every((control) => control.valid)
    this.invalid = !this.valid
  }

  reset () {
    Object.values(this.controls).forEach((control) => control.reset())
  }
}
